import React from 'react';
import Header from './Header';
import Footer from './Footer';

const About = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <div className="max-w-4xl mx-auto px-4 py-8 sm:py-12">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">About QuizCult</h1>
          <div className="prose prose-indigo max-w-none">
            <p className="text-gray-600 mb-4">
              QuizCult is an intelligent quiz generation platform that creates personalized quizzes on any topic you choose.
            </p>
            <p className="text-gray-600 mb-4">
              Whether you're studying, teaching, or just curious about a subject, QuizCult helps you test and expand your knowledge through interactive quizzes.
            </p>
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">Features</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              <li>Generate quizzes on any topic</li>
              <li>Choose difficulty levels</li>
              <li>Multiple question types</li>
              <li>Instant feedback and scoring</li>
              <li>Detailed performance analysis</li>
            </ul>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default About; 